import React, { useEffect, useState } from "react";
import PaginationComponent from "../../components/common/PaginationComponent";
import AppStore from "../../config/AppStore";
import {
  addDays,
  endOfMonth,
  endOfWeek,
  endOfYear,
  format,
  startOfMonth,
  startOfWeek,
  startOfYear,
} from "date-fns";
import { sendRequestGetPublisherOfferStatReports } from "../../view_logics/Reports/Reports";
import Spinner from "../../components/common/Spinner";
import { sendRequestGetPublishers } from "../../view_logics/Publishers";
import { useSelector } from "react-redux";
import DatePickerField from "../../components/common/DatePickerField";

const PublisherOfferStatReportsList = () => {
  const { userId, publisherId, username, userType } = useSelector(
    (state) => state?.login
  );
  console.log("🚀 ~ PublisherOfferStatReportsList ~ userId:", userId);
  let store = AppStore.getAppStoreInstance();
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reportsList, setReportsList] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [sortOrder, setSortOrder] = useState("asc"); // or 'desc'
  const [dateFieldEmpty, setDateFieldEmpty] = useState(false);
  const [displayStats, setDisplayStats] = useState([]);
  const [displayStatIndex, setDisplayStatIndex] = useState([]);
  const [reportsFilterLoading, setReportsFilterLoading] = useState(false);
  const [publishersList, setPublishersList] = useState([]);
  const [selectedPublisher, setSelectedPublisher] = useState(null);
  const todayDate = new Date();

  const inputObj = {
    accessToken: store.getState().login.accessToken,
    url: "reports",
    data: {
      from: todayDate?.toISOString().split("T")[0],
      to: todayDate?.toISOString().split("T")[0],
      offer_ids: [],
      publisher_id:
        publisherId != null ? publisherId : userId != null ? userId : "1",
    },
    dataHander: setApiData,
    loadingHandler: setReportsFilterLoading,
  };

  const getPublishersInputObj = {
    accessToken: store.getState().login.accessToken,
    url: "",
    dataHander: setPublishersList,
  };

  useEffect(() => {
    if (Array.isArray(apiData)) {
      const transformedData = [];
      const groupedData = {};

      // Iterate through the array and group objects by date
      apiData.forEach((item) => {
        const { date } = item;
        if (!groupedData[date]) {
          groupedData[date] = [item];
        } else {
          groupedData[date].push(item);
        }
      });

      Object.entries(groupedData).forEach(([date, dateArray]) => {
        transformedData.push({ date, dateArray });
      });

      if (transformedData) {
        setReportsList(transformedData);
      }
    }
  }, [apiData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await sendRequestGetPublisherOfferStatReports(inputObj);
        await sendRequestGetPublishers(getPublishersInputObj);
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const sortBy = (key) => {
    if (key == "desc") {
      setReportsList((prevList) => {
        const sortedData = [...prevList];
        const firstItem = sortedData.shift();
        sortedData.push(firstItem);
        return sortedData;
      });
    } else {
      setReportsList((prevList) => {
        const sortedData = [...prevList];
        const lastItem = sortedData.pop();
        sortedData.unshift(lastItem);
        return sortedData;
      });
    }
  };

  const handleDateRangeChange = (e) => {
    const selected = e.target.value;
    setSelectedDateRange(selected);

    const today = new Date();
    setDateFieldEmpty(true);

    switch (selected) {
      case "today":
        setFromDate(today);
        setToDate(today);
        break;
      case "yesterday":
        setFromDate(addDays(today, -1));
        setToDate(addDays(today, -1));
        break;
      case "thisWeek":
        setFromDate(startOfWeek(today));
        setToDate(endOfWeek(today));
        break;
      case "lastWeek":
        setFromDate(startOfWeek(addDays(today, -7)));
        setToDate(endOfWeek(addDays(today, -7)));
        break;
      case "thisMonth":
        setFromDate(startOfMonth(today));
        setToDate(endOfMonth(today));
        break;
      case "lastMonth":
        setFromDate(startOfMonth(addDays(today, -30)));
        setToDate(endOfMonth(addDays(today, -30)));
        break;
      case "thisYear":
        setFromDate(startOfYear(today));
        setToDate(endOfYear(today));
        break;
      default:
        break;
    }
  };

  const publisherChangeHandler = (e) => {
    const selected = e.target.value;
    setSelectedPublisher(selected);
  };
  const formatDate = (date) => format(date, "yyyy-MM-dd");

  const applyFilterHandler = () => {
    let postObject = {
      from: formatDate(fromDate),
      to: formatDate(toDate),
      publisher_id:
        publisherId != null ? publisherId : userId != null ? userId : "",
      loadingHandler: setReportsFilterLoading,
    };
    inputObj.data = postObject;

    const fetchData = async () => {
      try {
        setReportsFilterLoading(true);
        await sendRequestGetPublisherOfferStatReports(inputObj);
        setDisplayStatIndex();
        setDisplayStats([]);
      } catch (error) {
        setReportsFilterLoading(false);
        console.log("Error fetching data:", error);
      }
    };

    fetchData();
    setDisplayStats([]);
    setDisplayStatIndex(null)
  };

  const sumOfField = (item, name) => {
    const sumByKey = item.reduce((acc, obj) => {
      for (const key in obj) {
        if (
          key !== "advertiser_offer_id" ||
          key !== "offer_name" ||
          key !== "click_income" ||
          key !== "total_click_income"
        ) {
          acc[key] = Number(acc[key] || 0) + Number(obj[key]);
        }
      }
      return acc;
    }, {});
    let roundedNum = Math.round(sumByKey[name]);
    return roundedNum;
  };

  useEffect(() => {
    const newDate = new Date();
    setDateFieldEmpty(true);
    if (newDate) {
      setFromDate(newDate);
      setToDate(newDate);
    }
  }, []);

  const calculateTotalNestedECPM = (dateArray) => {
    const totalNestedECPM = dateArray.reduce((acc, item) => {
      const individualECPM =
        ((item.net_income || 0) / (item.impression_count || 1)) * 1000;
      return acc + individualECPM;
    }, 0);

    return totalNestedECPM.toFixed(2);
  };

  return (
    <div className="col-12 col-xl-12 position-relative">
      <div className="card">
        <div className="w-100 px-3 pt-3 d-flex">
          <div className="w-100 d-flex gap-1">
            {userType == "admin" && (
              <div className="d-flex w-25 gap-1 align-items-center">
                <label className="form-label mb-0" htmlFor="advertiserId">
                  Publisher:
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  value={selectedPublisher}
                  onChange={publisherChangeHandler}
                >
                  {/* <option value="">Select Publisher</option> */}
                  {publishersList.length > 0
                    ? publishersList.map((publisher) => (
                        <option key={publisher.id} value={publisher.id}>
                          {publisher?.first_name + " " + publisher?.last_name}
                        </option>
                      ))
                    : ""}
                </select>
              </div>
            )}
            <div className="w-50 d-flex gap-1 align-items-center">
              <div className="d-flex w-50">
                <select
                  className="form-select"
                  aria-label="select example"
                  value={selectedDateRange ? selectedDateRange : "today"}
                  onChange={handleDateRangeChange}
                >
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="thisWeek">This Week</option>
                  <option value="lastWeek">Last Week</option>
                  <option value="thisMonth">This Month</option>
                  <option value="lastMonth">Last Month</option>
                  <option value="thisYear">This Year</option>
                </select>
              </div>
              <div className="w-100 d-flex gap-1 align-items-center">
                <div className="w-50 d-flex gap-1 align-items-center justify-content-between">
                  <label className="form-label mb-0" htmlFor="advertiserId">
                    From:
                  </label>
                  <DatePickerField value={fromDate} setValue={setFromDate}/>
                  
                </div>

                <div className="w-50 d-flex gap-1 align-items-center justify-content-between">
                  <label className="form-label mb-0" htmlFor="advertiserId">
                    To:
                  </label>
                  <DatePickerField value={toDate} setValue={setToDate}/>
                  
                </div>
              </div>

              <div>
                {reportsFilterLoading ? (
                  <button
                    className="btn btn-primary d-flex gap-2 align-items-center"
                    type="button"
                    disabled
                  >
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Apply
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={applyFilterHandler}
                  >
                    Apply
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <hr />
        <table id="reports" className="table table-striped">
          <thead>
            <tr>
              <th scope="col" className="position-relative">
                Date{" "}
                
              </th>

              <th scope="col">
                Total Impressions{" "}
              
              </th>
              <th scope="col">
                Clicks{" "}
                
              </th>
              <th scope="col">
                Gross Revenue{" "}
                
              </th>

              <th scope="col">
                Net Revenue{" "}
              </th>
              

              <th scope="col">
                Net ECPM{" "}
                <i
                  className="fa-solid fa-circle-info"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title={`( Net Income / Impressions Count ) * 1000`}
                ></i>
                
              </th>
            </tr>
          </thead>
          <tbody>
            {reportsList.length > 0 ? (
              reportsList.map((report, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr key={index} className="table-info">
                      <td
                        title="Show Stats"
                        className="cursor-pointer"
                        onClick={() =>
                          displayStats.length > 0
                            ? setDisplayStats([])
                            : `${
                                (setDisplayStats(report.dateArray),
                                setDisplayStatIndex(index))
                              }`
                        }
                      >
                        {report.date}
                        <i
                          className={`${
                            displayStats.length > 0 && displayStatIndex == index
                              ? "fa-solid fa-circle-minus"
                              : "fa-solid fa-circle-plus"
                          } ps-3`}
                        ></i>
                      </td>
                      <td>
                        {sumOfField(report.dateArray, "impression_count")}
                      </td>
                      <td>{sumOfField(report.dateArray, "click_count")}</td>
                      <td>
                        {"$" + sumOfField(report.dateArray, "gross_income")}
                      </td>
                      <td>
                        {"$" + sumOfField(report.dateArray, "click_income")}
                      </td>
                      {/* <td>
                        {"$" + sumOfField(report.dateArray, "net_income")}
                      </td> */}
                      <td>{calculateTotalNestedECPM(report.dateArray)}</td>
                    </tr>
                    {displayStats.length > 0 && displayStatIndex == index && (
                      <>
                        {displayStats.map((item1, index1) => {
                          return (
                            <tr key={index1}>
                              <td style={{ paddingLeft: "40px" }}>
                                {item1.ad_unit_name}
                              </td>
                              <td>{item1.impression_count} </td>
                              <td>{item1.click_count}</td>
                              <td>{"$" + item1?.gross_income?.toFixed(2)}</td>
                              <td>{"$" + item1?.click_income?.toFixed(2)}</td>
                              {/* <td>{"$" + item1.net_income}</td> */}
                              <td>
                                {(
                                  ((item1.net_income || 0) /
                                    (item1.impression_count || 1)) *
                                  1000
                                ).toFixed(2)}
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan="12">No records found …</td>
              </tr>
            )}
          </tbody>
        </table>
        {/* <hr />
        <PaginationComponent /> */}
      </div>
      {/* {apiData == null && <Spinner/>} */}
    </div>
  );
};

export default PublisherOfferStatReportsList;
